import { isElectron } from "react-device-detect";
import { Logger } from "./Logger";
let ElectronInterop = typeof window !== "undefined" ? window._electron_interop : undefined;
if (!ElectronInterop) {
    try {
        ElectronInterop = typeof window !== "undefined" ? window.parent._electron_interop : undefined;
    }
    catch {
        Logger.error("Error trying to access parent window.");
    }
}
if (isElectron && !ElectronInterop) {
    const message = "A fatal error occurred! You may need to restart your app to update it. Please contact us if the issue persists.";
    Logger.warn(message);
}
export default ElectronInterop;
//# sourceMappingURL=ElectronInterop.js.map